module.exports = __webpack_public_path__ + "static/last-step-modal-d973cb0ecd68b974a4f4068628393fd6.jpg";